var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      attrs: {
        data: _vm.tableDatas,
        size: "mini",
        border: "",
        "max-height": 200,
      },
    },
    [
      _c("el-table-column", {
        attrs: { type: "index", label: "No.", width: "50" },
      }),
      _c("el-table-column", {
        attrs: { prop: "eightBitCode", label: "Local Number" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }